import { render, staticRenderFns } from "./DialogVideoPreview.vue?vue&type=template&id=c7ec0836&scoped=true"
import script from "./DialogVideoPreview.vue?vue&type=script&lang=js"
export * from "./DialogVideoPreview.vue?vue&type=script&lang=js"
import style0 from "./DialogVideoPreview.vue?vue&type=style&index=0&id=c7ec0836&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7ec0836",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Mobaxe\\Nevo.SimAdmin.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c7ec0836')) {
      api.createRecord('c7ec0836', component.options)
    } else {
      api.reload('c7ec0836', component.options)
    }
    module.hot.accept("./DialogVideoPreview.vue?vue&type=template&id=c7ec0836&scoped=true", function () {
      api.rerender('c7ec0836', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/DialogVideoPreview.vue"
export default component.exports